<script setup lang="ts">
import { InformationCircleIcon } from '@heroicons/vue/24/outline'
import {
    PopoverContent,
    type PopoverContentEmits,
    type PopoverContentProps,
    PopoverPortal,
    PopoverArrow,
    useForwardPropsEmits,
} from 'radix-vue'
import { type HTMLAttributes, computed } from 'vue'
import { cn } from '../../utils'

defineOptions({
    inheritAttrs: false,
})

const props = withDefaults(
    defineProps<PopoverContentProps & { class?: HTMLAttributes['class'] }>(),
    {
        align: 'center',
        sideOffset: 4,
    }
)
const emits = defineEmits<PopoverContentEmits>()

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
    <PopoverPortal>
        <PopoverContent
            v-bind="{ ...forwarded, ...$attrs }"
            :class="
                cn(
                    'z-50 max-w-72 rounded-md bg-white p-3 text-sm text-neutral-900 drop-shadow-md outline-hidden',
                    props.class
                )
            "
        >
            <div class="flex flex-row gap-x-2">
                <div class="flex-1">
                    <InformationCircleIcon class="size-5 text-primary-800" />
                </div>
                <div>
                    <slot />
                </div>
            </div>
            <PopoverArrow
                class="fill-white -mt-1"
                :width="20"
                :height="20"
                viewBox="0 0 10 10"
            ></PopoverArrow>
        </PopoverContent>
    </PopoverPortal>
</template>
